import { Badge, Button, ChoiceRadio, ChoiceRadioItem } from '@design-system';

import { FREEMIUM_INTENT_OPTIONS } from '@shared';

import { ChevronLeft, Sparkles } from 'lucide-react';

import type { FreemiumIntentId } from '@shared';
import type { ReactNode } from 'react';

interface IntentSelectorProps {
  clientFirstName: string;
  value: FreemiumIntentId | null;
  onChange: (intent: FreemiumIntentId) => void;
  onContinue: () => void;
  onBack: () => void;
  footer?: ReactNode;
}

export function IntentSelector({
  clientFirstName,
  value,
  onChange,
  onContinue,
  onBack,
  footer,
}: IntentSelectorProps) {
  return (
    <div className="mx-auto w-full max-w-xl">
      <div className="flex flex-col items-center gap-4 text-center">
        <Badge>
          <Sparkles />
          Let&apos;s tailor the next step
        </Badge>
        <h1 className="text-balance text-3xl font-bold text-gray-950">
          What are you trying to do next for {clientFirstName}?
        </h1>
      </div>

      <ChoiceRadio
        className="mt-6"
        value={value ?? undefined}
        onValueChange={next => onChange(next as FreemiumIntentId)}
      >
        {FREEMIUM_INTENT_OPTIONS.map(option => (
          <ChoiceRadioItem
            key={option.id}
            value={option.id}
            title={option.label}
            description={option.description}
          />
        ))}
      </ChoiceRadio>

      <Button
        className="mt-6 w-full"
        size="lg"
        disabled={!value}
        onClick={onContinue}
      >
        Continue
      </Button>

      <Button
        className="mt-3 w-full"
        size="lg"
        variant="outline"
        onClick={onBack}
      >
        <ChevronLeft />
        Back
      </Button>

      {footer}
    </div>
  );
}
